/**
 * Telegram 推播設定 schema — REQ-20260419007。
 * 全系統單一 chat 推播目標。botToken 以 AES-256-GCM 加密。
 */
import { z } from 'zod';

/** 使用者輸入。botToken 留空代表「保留原值」 */
export const TelegramSettingInputSchema = z.object({
  enabled: z.boolean().default(false),
  botToken: z.string().max(500).default(''),
  // chatId: 個人為正整數;群組 / channel 可能為負整數或 @username
  chatId: z.string().trim().max(100).default(''),
});
export type TelegramSettingInput = z.infer<typeof TelegramSettingInputSchema>;

export const TelegramSettingViewSchema = z.object({
  enabled: z.boolean(),
  hasBotToken: z.boolean(),
  chatId: z.string(),
  updatedAt: z.string().datetime().nullable(),
});
export type TelegramSettingView = z.infer<typeof TelegramSettingViewSchema>;

export const TelegramTestResultSchema = z.object({
  ok: z.boolean(),
  message: z.string(),
});
export type TelegramTestResult = z.infer<typeof TelegramTestResultSchema>;
